import { hasChildren as e } from "../helpers/selectionProcessing.js";
import { TreeNodeHeader as t } from "../TreeNodeHeader/TreeNodeHeader.js";
import n from "./TreeNodeElement.module.js";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/Tree/TreeNodeElement/TreeNodeElement.tsx
var a = (a) => {
	let o = r(17), { depth: s, node: c, selection: l, search: u, expandedIds: d, onExpandToggle: f, onSelect: p } = a, { helpTextElement: m, id: h } = c, g;
	o[0] !== d || o[1] !== m || o[2] !== c || o[3] !== h ? (g = (e(c) || !!m) && d.has(h), o[0] = d, o[1] = m, o[2] = c, o[3] = h, o[4] = g) : g = o[4];
	let _ = g, v;
	o[5] === s ? v = o[6] : (v = { "--qd-tree-depth": s }, o[5] = s, o[6] = v);
	let y = v, b;
	o[7] !== _ || o[8] !== c || o[9] !== f || o[10] !== p || o[11] !== u || o[12] !== l ? (b = /* @__PURE__ */ i(t, {
		node: c,
		selection: l,
		isExpanded: _,
		onExpandToggle: f,
		onSelect: p,
		search: u
	}), o[7] = _, o[8] = c, o[9] = f, o[10] = p, o[11] = u, o[12] = l, o[13] = b) : b = o[13];
	let x;
	return o[14] !== y || o[15] !== b ? (x = /* @__PURE__ */ i("div", {
		className: n.row,
		style: y,
		children: b
	}), o[14] = y, o[15] = b, o[16] = x) : x = o[16], x;
};
//#endregion
export { a as TreeNodeElement };
